// import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { db } from './Firebase';
// import { doc, getDoc, setDoc } from 'firebase/firestore';
// import Swal from 'sweetalert2';

// const FeedbackUser = () => {
//   const [order, setOrder] = useState(null);
//   const [rating, setRating] = useState(0);
//   const [submitted, setSubmitted] = useState(false);
//   const query = new URLSearchParams(useLocation().search);
//   const orderId = query.get('orderId');

//   useEffect(() => {
//     const fetchOrder = async () => {
//       if (!orderId) return;
//       try {
//         const docRef = doc(db, 'Billing', orderId);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//           setOrder(docSnap.data());
//         } else {
//           Swal.fire('Error', 'Order not found', 'error');
//         }
//       } catch (error) {
//         Swal.fire('Error', 'Failed to fetch order', 'error');
//       }
//     };

//     fetchOrder();
//   }, [orderId]);

//   const handleSubmit = async () => {
//     if (rating === 0) {
//       Swal.fire('Error', 'Please select a rating.', 'warning');
//       return;
//     }

//     try {
//       await setDoc(doc(db, 'Feedback', orderId), {
//         orderId,
//         rating,
//         timestamp: new Date()
//       });
//       setSubmitted(true);
//       Swal.fire('Thank You!', 'Your feedback has been submitted.', 'success');
//     } catch (error) {
//       Swal.fire('Error', 'Failed to submit feedback.', 'error');
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={{ color: 'white' }}>Order Feedback</h2>
//       {order ? (
//         <>
//           <p style={{ color: 'white' }}><strong>Name:</strong> {order.name}</p>
//           <p style={{ color: 'white' }}><strong>Total:</strong> ₹{order.totalAmount}</p>
//           <p style={{ color: 'white' }}><strong>Items:</strong> {order.items?.map(item => item.Name).join(', ')}</p>

//           <div style={{ marginTop: '20px' }}>
//             <p style={{ color: 'white' }}>Rate your experience:</p>
//             <div style={styles.stars}>
//               {[1, 2, 3, 4, 5].map((star) => (
//                 <span
//                   key={star}
//                   style={rating >= star ? styles.activeStar : styles.star}
//                   onClick={() => setRating(star)}
//                 >
//                   ★
//                 </span>
//               ))}
//             </div>
//             <button className="btn btn-success mt-3" onClick={handleSubmit} disabled={submitted}>
//               {submitted ? 'Submitted' : 'Submit Feedback'}
//             </button>
//           </div>
//         </>
//       ) : (
//         <p style={{ color: 'white' }}>Loading order details...</p>
//       )}
//     </div>
//   );
// };

// const styles = {
//   container: {
//     backgroundColor: '#2c3e50',
//     padding: '40px',
//     minHeight: '100vh',
//     color: 'white',
//   },
//   stars: {
//     fontSize: '30px',
//     cursor: 'pointer',
//     display: 'flex',
//     gap: '10px',
//   },
//   star: {
//     color: '#ccc',
//   },
//   activeStar: {
//     color: '#ffc107',
//   },
// };

// export default FeedbackUser;

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from './Firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import Swal from 'sweetalert2';
import confetti from 'canvas-confetti';

const FeedbackUser = () => {
  const [order, setOrder] = useState(null);
  const [rating, setRating] = useState(0);
  const [hoveredStar, setHoveredStar] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [emoji, setEmoji] = useState('');

  const query = new URLSearchParams(useLocation().search);
  const orderId = query.get('orderId') || localStorage.getItem('orderId');

  useEffect(() => {
    const fetchOrder = async () => {
      if (!orderId) return;
      try {
        const docRef = doc(db, 'Billing', orderId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setOrder(docSnap.data());
        } else {
          Swal.fire('Error', 'Order not found.', 'error');
        }
      } catch (error) {
        Swal.fire('Error', 'Failed to fetch order.', 'error');
      }
    };
    fetchOrder();
  }, [orderId]);

  const handleSubmit = async () => {
    if (rating === 0) {
      Swal.fire('Error', 'Please select a rating.', 'warning');
      return;
    }

    try {
      await setDoc(doc(db, 'Feedback', orderId), {
        orderId,
        rating,
        feedbackText,
        emoji,
        timestamp: new Date(),
      });
      setSubmitted(true);
      confetti();
      Swal.fire({
        icon: 'success',
        title: 'Feedback Submitted',
        html: `<p>Thanks for your ${rating}-star rating!</p><p>Your feedback: ${feedbackText || 'No comment'}</p>`
      });
    } catch (error) {
      Swal.fire('Error', 'Failed to submit feedback.', 'error');
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Rate Your Order</h2>

        {order ? (
          <>
            <div style={styles.details}>
              <div><strong>Name:</strong> {order.name || 'N/A'}</div>
              <div><strong>Email:</strong> {order.email || 'N/A'}</div>
              <div><strong>Contact:</strong> {order.contact || 'N/A'}</div>
              <div><strong>Total:</strong> ₹{order.totalAmount || 0}</div>
              <div><strong>Items:</strong> {order.items?.map(item => item.Name).join(', ') || 'N/A'}</div>
            </div>

            <div style={styles.feedback}>
              <p style={styles.label}>How was your experience?</p>
              <div style={styles.stars}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    style={star <= (hoveredStar || rating) ? styles.activeStar : styles.star}
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHoveredStar(star)}
                    onMouseLeave={() => setHoveredStar(0)}
                  >
                    ★
                  </span>
                ))}
              </div>

              <textarea
                placeholder="Leave a comment (optional)"
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
                style={styles.textarea}
              />

              <div style={styles.emojiPicker}>
                {['😊', '😐', '😞'].map((e) => (
                  <span
                    key={e}
                    onClick={() => setEmoji(e)}
                    style={{
                      fontSize: '28px',
                      margin: '0 10px',
                      cursor: 'pointer',
                      opacity: emoji === e ? 1 : 0.5,
                    }}
                  >
                    {e}
                  </span>
                ))}
              </div>

              <button
                style={{ ...styles.button, ...(submitted ? styles.buttonDisabled : {}) }}
                onClick={handleSubmit}
                disabled={submitted}
              >
                {submitted ? '✅ Feedback Submitted' : 'Submit Feedback'}
              </button>
            </div>
          </>
        ) : (
          <p style={styles.loading}>Loading your order details...</p>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: {
    background: 'linear-gradient(120deg, #e0eafc, #cfdef3)',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontFamily: 'Inter, sans-serif',
  },
  card: {
    width: '100%',
    maxWidth: '650px',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    padding: '35px 40px',
    textAlign: 'center',
  },
  title: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#333',
    marginBottom: '25px',
  },
  details: {
    textAlign: 'left',
    color: '#444',
    fontSize: '16px',
    marginBottom: '25px',
    lineHeight: '1.6',
  },
  feedback: {
    textAlign: 'center',
  },
  label: {
    fontSize: '18px',
    color: '#222',
    marginBottom: '12px',
  },
  stars: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '34px',
    marginBottom: '20px',
  },
  star: {
    cursor: 'pointer',
    color: '#bbb',
    transition: 'transform 0.2s, color 0.2s',
  },
  activeStar: {
    cursor: 'pointer',
    color: '#f39c12',
    transform: 'scale(1.2)',
    transition: 'transform 0.2s, color 0.2s',
  },
  textarea: {
    width: '100%',
    padding: '10px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    resize: 'none',
    fontSize: '15px',
    marginBottom: '15px',
    height: '80px',
  },
  emojiPicker: {
    marginBottom: '20px',
  },
  button: {
    padding: '12px 30px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '6px',
    backgroundColor: '#2ecc71',
    color: '#fff',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.3s ease',
  },
  buttonDisabled: {
    backgroundColor: '#95a5a6',
    cursor: 'not-allowed',
  },
  loading: {
    fontSize: '18px',
    color: '#333',
  },
};

export default FeedbackUser;